export default function PHP_readlink() {
  return (
    <div>
      <h1>PHP_readlink</h1>
    </div>
  );
}
